module.exports = __webpack_public_path__ + "static/slide-dog-4-f79939c9da9cd7bedb8dfafe9bb2ba78.png";